import type { Category, Video } from '@/types/video';

export const categories: Category[] = [
  { id: 'movie', name: '电影', icon: 'ri-film-line', description: '汇聚院线级剧情长片与类型电影，感受大银幕般的观影体验。' },
  { id: 'series', name: '电视剧', icon: 'ri-tv-2-line', description: '热播剧集与经典台剧港剧，人物丰满、剧情紧凑，追更不间断。' },
  { id: 'short', name: '短片', icon: 'ri-movie-2-line', description: '十分钟以内的创意短片与微电影，碎片时间也能收获惊喜。' },
  { id: 'variety', name: '综艺', icon: 'ri-mic-line', description: '欢乐真人秀与竞技综艺，为枯燥日常注入轻松解压的能量。' },
  { id: 'anime', name: '动漫', icon: 'ri-magic-line', description: '热血、治愈与奇幻动画，承包你所有的想象力与少年感。' },
  { id: 'documentary', name: '纪录片', icon: 'ri-earth-line', description: '自然、人文与历史纪实，带你看见这个更大更真实的世界。' },
];

export const videos: Video[] = [
  {
    id: 'm01',
    title: '星海远征',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20science%20fiction%20adventure%20film%2C%20a%20lone%20astronaut%20walking%20toward%20a%20colossal%20glowing%20starship%20on%20an%20alien%20desert%20plain%20at%20dusk%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-m01&orientation=landscape',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20key%20art%20for%20a%20science%20fiction%20journey%20film%2C%20vast%20fleet%20of%20starships%20drifting%20above%20a%20purple%20nebula%20horizon%20with%20a%20silhouetted%20astronaut%20in%20the%20foreground%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=pv-b01&orientation=landscape',
    duration: '02:18:30',
    categoryId: 'movie',
    categoryName: '电影',
    tags: ['科幻', '冒险', '剧情'],
    region: '内地',
    year: '2025',
    rating: 9.2,
    views: 12840000,
    likes: 482000,
    uploadDate: '2025-09-28',
    description: '当地球的最后一束信号消失，一支由五名宇航员组成的远征队驶向深空。他们要在神秘的星海里寻找失联的殖民舰队，也在未知中重新认识彼此与家园的意义。',
    featured: true,
  },
  {
    id: 'm02',
    title: '雾都往事',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20noir%20mystery%20drama%20film%2C%20rain%20slicked%20old%20city%20street%20at%20night%20with%20a%20solitary%20detective%20in%20a%20long%20coat%20under%20a%20dim%20street%20lamp%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-m02&orientation=landscape',
    duration: '01:56:12',
    categoryId: 'movie',
    categoryName: '电影',
    tags: ['悬疑', '剧情', '犯罪'],
    region: '港台',
    year: '2024',
    rating: 8.6,
    views: 8420000,
    likes: 214000,
    uploadDate: '2025-08-14',
    description: '一桩尘封二十年的旧案在雾都重新浮出水面。退休警探循着一张模糊的老照片，抽丝剥茧，走进一座城市最深的记忆与谎言之中。',
  },
  {
    id: 'm03',
    title: '长夜将尽',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20tense%20thriller%20drama%20film%2C%20a%20family%20sheltering%20in%20a%20dim%20mountain%20cabin%20while%20a%20storm%20rages%20outside%2C%20single%20warm%20lantern%20glowing%20against%20cold%20shadows%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-m03&orientation=landscape',
    duration: '02:04:45',
    categoryId: 'movie',
    categoryName: '电影',
    tags: ['剧情', '悬疑', '家庭'],
    region: '内地',
    year: '2025',
    rating: 8.9,
    views: 6530000,
    likes: 198000,
    uploadDate: '2025-09-12',
    description: '长夜笼罩的小镇停电七十二小时，一家人被迫在黑暗中面对彼此隐瞒多年的秘密。当第一缕晨光降临，他们必须决定原谅还是告别。',
  },
  {
    id: 'm04',
    title: '归途列车',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20heartfelt%20road%20drama%20film%2C%20an%20old%20green%20train%20crossing%20golden%20plains%20at%20sunset%20seen%20from%20a%20distance%2C%20warm%20nostalgic%20atmosphere%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-m04&orientation=landscape',
    duration: '01:42:08',
    categoryId: 'movie',
    categoryName: '电影',
    tags: ['剧情', '爱情', '治愈'],
    region: '内地',
    year: '2023',
    rating: 8.1,
    views: 4210000,
    likes: 121000,
    uploadDate: '2024-12-03',
    description: '一趟横穿大陆的绿皮列车，载着两个陌生人跨越三千公里。旅途中的对话与风景，让一段迟到的爱情在终点站悄然相遇。',
  },
  {
    id: 's01',
    title: '繁花落尽',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20an%20urban%20romance%20drama%20series%2C%20a%20graceful%20woman%20in%20a%20red%20coat%20standing%20in%20a%20neon%20lit%20old%20town%20alley%20at%20night%2C%20warm%20bokeh%20lights%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-s01&orientation=landscape',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20art%20for%20an%20urban%20romance%20drama%20series%2C%20a%20rainy%20neon%20old%20town%20street%20with%20reflections%20and%20a%20distant%20solitary%20figure%20beneath%20an%20umbrella%2C%20warm%20glowing%20shop%20signs%20against%20deep%20indigo%20darkness%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=pv-b02&orientation=landscape',
    duration: '45:12',
    categoryId: 'series',
    categoryName: '电视剧',
    tags: ['剧情', '爱情', '都市'],
    region: '内地',
    year: '2025',
    rating: 9.0,
    views: 18900000,
    likes: 623000,
    uploadDate: '2025-09-30',
    description: '上世纪九十年代的南方都市，繁花盛开又凋落。三个年轻人在时代浪潮里追逐理想与爱情，见证一段属于普通人的黄金年代。',
    featured: true,
  },
  {
    id: 's02',
    title: '山河故人录',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20an%20epic%20historical%20drama%20series%2C%20ancient%20Chinese%20mountain%20fortress%20at%20golden%20dusk%20with%20armored%20figures%20on%20the%20walls%2C%20sweeping%20misty%20landscape%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-s02&orientation=landscape',
    duration: '42:36',
    categoryId: 'series',
    categoryName: '电视剧',
    tags: ['历史', '剧情', '战争'],
    region: '内地',
    year: '2024',
    rating: 8.8,
    views: 12400000,
    likes: 402000,
    uploadDate: '2025-07-22',
    description: '乱世之中，一位年轻的守将以一座孤城挡住千军。铁血与柔情的抉择里，他守住的不只是山河，还有心中最后一份道义。',
  },
  {
    id: 's03',
    title: '都市迷航',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20modern%20mystery%20thriller%20series%2C%20a%20lone%20figure%20crossing%20a%20vast%20empty%20city%20crossroad%20at%20night%20with%20long%20shadows%20and%20towering%20glass%20buildings%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-s03&orientation=landscape',
    duration: '44:05',
    categoryId: 'series',
    categoryName: '电视剧',
    tags: ['悬疑', '都市', '犯罪'],
    region: '港台',
    year: '2025',
    rating: 8.4,
    views: 9750000,
    likes: 288000,
    uploadDate: '2025-09-05',
    description: '深夜的城市里连续发生诡异的失踪案，一位失眠的记者在追查真相的过程中，发现自己也早已迷失在这座钢铁森林之中。',
  },
  {
    id: 's04',
    title: '旧巷灯火',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20warm%20slice%20of%20life%20drama%20series%2C%20an%20old%20residential%20alley%20in%20a%20southern%20town%20with%20glowing%20windows%20and%20hanging%20lanterns%20at%20night%2C%20cozy%20nostalgic%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-s04&orientation=landscape',
    duration: '41:20',
    categoryId: 'series',
    categoryName: '电视剧',
    tags: ['剧情', '治愈', '家庭'],
    region: '内地',
    year: '2023',
    rating: 8.2,
    views: 6120000,
    likes: 176000,
    uploadDate: '2024-11-09',
    description: '一条老巷、几户人家、数不清的柴米油盐。日子平淡却热气腾腾，灯火亮起的地方，就是最踏实的归处。',
  },
  {
    id: 'h01',
    title: '十分钟的城市',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20poetic%20short%20film%2C%20a%20sweeping%20time%20lapse%20view%20over%20an%20old%20city%20skyline%20shifting%20from%20dusk%20to%20night%20with%20drifting%20clouds%20and%20glowing%20lights%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-h01&orientation=landscape',
    duration: '09:48',
    categoryId: 'short',
    categoryName: '短片',
    tags: ['文艺', '纪录', '城市'],
    region: '内地',
    year: '2025',
    rating: 8.7,
    views: 3420000,
    likes: 142000,
    uploadDate: '2025-09-20',
    description: '用十分钟的镜头，记录一座城市从黄昏到深夜的呼吸节奏。那些被匆忙忽略的细节，正是城市最柔软的心跳。',
  },
  {
    id: 'h02',
    title: '窗边的夏天',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20gentle%20youth%20romance%20short%20film%2C%20sunlight%20streaming%20through%20a%20window%20onto%20a%20quiet%20study%20desk%20with%20drifting%20dust%20and%20a%20small%20potted%20plant%2C%20warm%20nostalgic%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-h02&orientation=landscape',
    duration: '12:30',
    categoryId: 'short',
    categoryName: '短片',
    tags: ['治愈', '爱情', '青春'],
    region: '日韩',
    year: '2024',
    rating: 8.5,
    views: 2980000,
    likes: 118000,
    uploadDate: '2025-06-18',
    description: '一个闷热的暑假，少年每天在窗边写作业，也不断偷看对面楼的女孩。直到某个傍晚，他们终于在同一片晚霞下说了第一句话。',
  },
  {
    id: 'h03',
    title: '雨夜信号',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20sci%20fi%20mystery%20short%20film%2C%20a%20vintage%20radio%20glowing%20in%20a%20dark%20room%20while%20heavy%20rain%20streaks%20the%20window%2C%20faint%20electrical%20sparks%20and%20static%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-h03&orientation=landscape',
    duration: '14:02',
    categoryId: 'short',
    categoryName: '短片',
    tags: ['科幻', '悬疑', '惊悚'],
    region: '内地',
    year: '2025',
    rating: 8.3,
    views: 2540000,
    likes: 96000,
    uploadDate: '2025-09-02',
    description: '一个雨夜，独居的工程师收到了一段来自七年前的无线电信号。顺着信号追查下去，他触碰到的是一段无法解释的时空裂痕。',
  },
  {
    id: 'h04',
    title: '最后一班地铁',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20an%20urban%20drama%20short%20film%2C%20an%20empty%20late%20night%20subway%20platform%20with%20flickering%20lights%20and%20a%20single%20waiting%20passenger%20near%20the%20yellow%20line%2C%20cold%20atmosphere%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-h04&orientation=landscape',
    duration: '11:15',
    categoryId: 'short',
    categoryName: '短片',
    tags: ['都市', '剧情', '情感'],
    region: '港台',
    year: '2023',
    rating: 7.9,
    views: 1860000,
    likes: 68000,
    uploadDate: '2024-10-21',
    description: '末班地铁上只剩两个人。一个刚失去工作，一个刚结束一段感情。空荡的车厢里，两个失意的人用一段短暂对话温暖了彼此。',
  },
  {
    id: 'v01',
    title: '欢乐实验室',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20lively%20comedic%20variety%20show%20stage%2C%20colorful%20spotlights%20over%20an%20empty%20playful%20set%20with%20props%20and%20confetti%20in%20the%20air%2C%20energetic%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-v01&orientation=landscape',
    duration: '78:24',
    categoryId: 'variety',
    categoryName: '综艺',
    tags: ['喜剧', '真人秀', '搞笑'],
    region: '内地',
    year: '2025',
    rating: 8.6,
    views: 15600000,
    likes: 534000,
    uploadDate: '2025-09-27',
    description: '一群脑洞大开的嘉宾，在奇奇怪怪的实验任务里不断翻车又不断翻盘。本期节目挑战「用一句话让全场笑出声」。',
  },
  {
    id: 'v02',
    title: '旅行吧朋友',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20warm%20travel%20reality%20show%2C%20a%20small%20group%20of%20friends%20silhouetted%20on%20a%20mountain%20ridge%20watching%20a%20sunset%20over%20misty%20valleys%2C%20adventurous%20and%20cozy%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-v02&orientation=landscape',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20art%20for%20a%20travel%20reality%20show%2C%20friends%20pitching%20a%20tent%20on%20a%20misty%20mountain%20plateau%20under%20a%20vast%20starry%20sky%20with%20warm%20campfire%20glow%2C%20adventurous%20cozy%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=pv-b03&orientation=landscape',
    duration: '92:10',
    categoryId: 'variety',
    categoryName: '综艺',
    tags: ['真人秀', '治愈', '旅行'],
    region: '内地',
    year: '2025',
    rating: 8.9,
    views: 13200000,
    likes: 498000,
    uploadDate: '2025-09-14',
    description: '六位好友开着房车穿越高原与草原，没有剧本、没有任务，只有一路的风景与真心话。这一站，他们要在雪山脚下搭帐篷看星星。',
    featured: true,
  },
  {
    id: 'v03',
    title: '超级大挑战',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20competitive%20game%20show%20arena%2C%20an%20obstacle%20course%20glowing%20with%20edge%20lights%20in%20a%20dark%20stadium%20with%20dramatic%20spotlights%2C%20intense%20energetic%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-v03&orientation=landscape',
    duration: '86:45',
    categoryId: 'variety',
    categoryName: '综艺',
    tags: ['竞技', '真人秀', '热血'],
    region: '内地',
    year: '2024',
    rating: 8.0,
    views: 8700000,
    likes: 236000,
    uploadDate: '2025-05-30',
    description: '来自全国各地的挑战者同场竞技，闯过一道道极限关卡。汗水、协作与不甘落后，构成了这个夏天最热血的篇章。',
  },
  {
    id: 'v04',
    title: '厨房大作战',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20cooking%20competition%20variety%20show%2C%20a%20warm%20cozy%20professional%20kitchen%20with%20sizzling%20pans%2C%20steam%20and%20glowing%20stove%20flames%20at%20night%2C%20appetizing%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-v04&orientation=landscape',
    duration: '70:18',
    categoryId: 'variety',
    categoryName: '综艺',
    tags: ['美食', '真人秀', '竞技'],
    region: '内地',
    year: '2024',
    rating: 8.3,
    views: 7400000,
    likes: 202000,
    uploadDate: '2025-04-12',
    description: '八位素人厨师同台竞技，用有限食材完成命题创作。灶火、香气与紧张倒计时里，藏着最朴素也最动人的人间烟火。',
  },
  {
    id: 'a01',
    title: '幻境行者',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20fantasy%20anime%20series%2C%20a%20young%20hero%20with%20a%20glowing%20magical%20sword%20standing%20before%20an%20enormous%20floating%20island%20and%20swirling%20magical%20portal%20in%20the%20sky%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-a01&orientation=landscape',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20art%20for%20a%20fantasy%20anime%20adventure%2C%20a%20vast%20floating%20continent%20surrounded%20by%20glowing%20runes%20above%20a%20sea%20of%20clouds%20with%20a%20tiny%20hero%20silhouette%20on%20a%20cliff%20edge%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=pv-b04&orientation=landscape',
    duration: '24:06',
    categoryId: 'anime',
    categoryName: '动漫',
    tags: ['奇幻', '冒险', '热血'],
    region: '日韩',
    year: '2025',
    rating: 9.1,
    views: 16200000,
    likes: 712000,
    uploadDate: '2025-09-29',
    description: '少年在一次意外中获得了穿梭幻境的能力。为了寻找失踪的姐姐，他踏上穿越无数平行世界的旅途，并在其中逐渐揭开世界的真相。',
    featured: true,
  },
  {
    id: 'a02',
    title: '机械之心',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20mecha%20science%20fiction%20anime%2C%20a%20giant%20humanoid%20robot%20kneeling%20in%20a%20ruined%20neon%20city%20at%20night%20while%20a%20small%20pilot%20stands%20before%20it%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-a02&orientation=landscape',
    duration: '23:42',
    categoryId: 'anime',
    categoryName: '动漫',
    tags: ['科幻', '热血', '机甲'],
    region: '内地',
    year: '2025',
    rating: 8.8,
    views: 11800000,
    likes: 452000,
    uploadDate: '2025-09-08',
    description: '在被废弃的城市里，一台沉睡的巨型机甲被少年唤醒。它拥有残缺却真诚的「心」，而少年要教会它，什么才是真正的强大。',
  },
  {
    id: 'a03',
    title: '夏日少年',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20gentle%20youth%20anime%20series%2C%20two%20students%20on%20a%20seaside%20railway%20platform%20at%20golden%20hour%20watching%20a%20train%20pass%2C%20warm%20nostalgic%20summer%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-a03&orientation=landscape',
    duration: '24:30',
    categoryId: 'anime',
    categoryName: '动漫',
    tags: ['治愈', '青春', '校园'],
    region: '日韩',
    year: '2024',
    rating: 8.7,
    views: 9300000,
    likes: 386000,
    uploadDate: '2025-07-16',
    description: '海边小镇的最后一个夏天，一群体校少年在棒球场上挥洒汗水。关于梦想、友情与离别，在这个蝉鸣不止的季节里悄悄生长。',
  },
  {
    id: 'a04',
    title: '云端纪事',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20fantasy%20anime%20series%2C%20a%20floating%20airship%20sailing%20through%20towering%20golden%20clouds%20above%20a%20hidden%20mountain%20city%20at%20dawn%2C%20dreamy%20adventurous%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-a04&orientation=landscape',
    duration: '22:58',
    categoryId: 'anime',
    categoryName: '动漫',
    tags: ['奇幻', '剧情', '冒险'],
    region: '内地',
    year: '2023',
    rating: 8.4,
    views: 6800000,
    likes: 214000,
    uploadDate: '2024-09-25',
    description: '传说云端之上漂浮着失落的天空之城。一名年轻的飞艇领航员为了完成祖父的遗愿，踏上了寻找这座城市的漫长航行。',
  },
  {
    id: 'd01',
    title: '大地脉动',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20nature%20documentary%2C%20a%20herd%20of%20wild%20horses%20galloping%20across%20a%20vast%20golden%20grassland%20at%20sunset%20with%20distant%20snow%20mountains%2C%20epic%20natural%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-d01&orientation=landscape',
    duration: '55:20',
    categoryId: 'documentary',
    categoryName: '纪录片',
    tags: ['自然', '纪实', '动物'],
    region: '欧美',
    year: '2025',
    rating: 9.3,
    views: 8900000,
    likes: 342000,
    uploadDate: '2025-09-18',
    description: '横跨四大洲五大生态系统，用超高速与微距镜头记录生命的迁徙与轮回。每一帧，都是大地最震撼的呼吸。',
  },
  {
    id: 'd02',
    title: '城市之下',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20an%20urban%20humanity%20documentary%2C%20a%20network%20of%20glowing%20underground%20tunnels%20and%20pipes%20beneath%20a%20modern%20city%2C%20moody%20industrial%20atmosphere%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-d02&orientation=landscape',
    duration: '48:40',
    categoryId: 'documentary',
    categoryName: '纪录片',
    tags: ['人文', '纪实', '城市'],
    region: '内地',
    year: '2024',
    rating: 8.5,
    views: 5600000,
    likes: 168000,
    uploadDate: '2025-06-05',
    description: '当我们抬头仰望摩天大楼时，城市的地下正悄悄运转着另一套生命系统。这部纪录片，讲述那些支撑城市、却常被忽略的人们。',
  },
  {
    id: 'd03',
    title: '舌尖四季',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20a%20Chinese%20food%20culture%20documentary%2C%20a%20rustic%20kitchen%20table%20filled%20with%20steaming%20seasonal%20dishes%20and%20fresh%20harvest%20ingredients%20by%20an%20old%20window%2C%20warm%20appetizing%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-d03&orientation=landscape',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20art%20for%20a%20food%20culture%20documentary%2C%20a%20traditional%20open%20air%20kitchen%20at%20dusk%20with%20steaming%20woks%20and%20hanging%20lanterns%20surrounded%20by%20autumn%20fields%2C%20warm%20appetizing%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20no%20text&width=1600&height=900&seq=pv-b05&orientation=landscape',
    duration: '52:16',
    categoryId: 'documentary',
    categoryName: '纪录片',
    tags: ['美食', '纪实', '人文'],
    region: '内地',
    year: '2025',
    rating: 9.0,
    views: 10400000,
    likes: 412000,
    uploadDate: '2025-08-30',
    description: '跟着二十四节气走过四季，从早春的野菜到冬日的腌味，看中国人如何用一双双手，把时间和土地变成餐桌上的乡愁。',
    featured: true,
  },
  {
    id: 'd04',
    title: '深蓝秘境',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20for%20an%20ocean%20nature%20documentary%2C%20a%20majestic%20whale%20gliding%20through%20glowing%20deep%20blue%20ocean%20depths%20with%20shafts%20of%20light%20from%20above%2C%20mysterious%20epic%20mood%2C%20deep%20indigo%20and%20near-black%20tones%20with%20warm%20orange%20rim%20light%2C%20volumetric%20haze%2C%20dramatic%20cinematic%20composition%2C%20subtle%20film%20grain%2C%20ultra%20detailed%2C%20wide%2016%20by%209%20cover%20art%2C%20no%20text&width=640&height=360&seq=pv-d04&orientation=landscape',
    duration: '50:02',
    categoryId: 'documentary',
    categoryName: '纪录片',
    tags: ['自然', '纪实', '海洋'],
    region: '欧美',
    year: '2023',
    rating: 8.9,
    views: 7200000,
    likes: 256000,
    uploadDate: '2024-08-11',
    description: '潜入阳光无法抵达的深海，记录那些从未被人类目睹的奇异生命。这片幽暗的蓝色秘境，依然藏着地球最后的未解之谜。',
  },
];

export const siteIntro = {
  name: '啪啪视频',
  slogan: '好内容，随时随地看',
  intro:
    '啪啪视频是一个专注于高清视频内容分享与在线播放的平台。我们聚合电影、电视剧、短片、综艺、动漫与纪录片等多类型资源，持续为你发现最新、最热的精彩内容。无论你使用手机还是电脑，都能获得清晰、流畅、舒适的浏览体验。',
};